import { Phone } from 'lucide-react';
import { MessageIcon, WhatsAppIcon } from '@/components/property/ContactIcons';
import { Button } from '@/components/ui/button';

interface Props {
  phone?: string;
  whatsapp?: string;
  projectName?: string;
  referenceCode?: string;
  onMessageClick?: () => void;
}

/**
 * Compact contact action bar shown at the TOP of the project detail page
 * (mobile + tablet). Mirrors the bottom CTA so users always have a contact
 * row in view, Zameen-style.
 */
export function ProjectTopContactBar({ phone = '+251', whatsapp = '251', projectName, referenceCode, onMessageClick }: Props) {
  const wa = (whatsapp || '').replace(/\D/g, '');
  const refId = (referenceCode || '').toUpperCase();
  const waText = encodeURIComponent(
    `Hi, I'd like to inquire about ${projectName || 'this project'}${refId ? ` (${refId})` : ''}. Please share availability, pricing and next steps.`
  );
  const handleMessage = () => {
    if (onMessageClick) return onMessageClick();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  return (
    <div className="lg:hidden grid grid-cols-3 gap-2 mb-4">
      <Button asChild className="h-11 font-bold gap-2 text-sm">
        <a href={`tel:${phone}`} aria-label="Call">
          <Phone className="h-4 w-4" /> Call
        </a>
      </Button>
      <Button asChild variant="outline" className="h-11 font-bold gap-2 text-sm border-primary/30 hover:bg-primary/5">
        <a href={`https://wa.me/${wa}?text=${waText}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
          <WhatsAppIcon className="h-4 w-4" /> WhatsApp
        </a>
      </Button>
      <Button onClick={handleMessage} variant="outline" className="h-11 font-bold gap-2 text-sm border-primary/40 text-primary hover:bg-primary/5">
        <MessageIcon className="h-4 w-4" /> Message
      </Button>
    </div>
  );
}
